import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = axios.create({ baseURL: `${BACKEND_URL}/api` });
export const absUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);
export const fileUrl = (id) => `${BACKEND_URL}/api/files/${id}?auth=${localStorage.getItem('np_token')}`;
export const coverUrl = (couple) => couple?.coverFileId && couple?.slug ? `${BACKEND_URL}/api/inv/${couple.slug}/cover?v=${couple.coverFileId}` : null;

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('np_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('np_token');
      localStorage.removeItem('np_user');
      if (!window.location.pathname.match(/^\/(login|register|onboarding|)$/)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

// Auth
export const authRegister = (data) => API.post('/auth/register', data).then(r => r.data);
export const authLogin = (data) => API.post('/auth/login', data).then(r => r.data);
export const authMe = () => API.get('/auth/me').then(r => r.data);
export const authGoogleSession = (session_id) => API.post('/auth/google/session', { session_id }).then(r => r.data);

// Payment
export const getPaymentInfo = () => API.get('/payment/info').then(r => r.data);
export const getPaymentStatus = () => API.get('/payment/status').then(r => r.data);
export const confirmPayment = (data) => API.post('/payment/confirm', data).then(r => r.data);
export const uploadProof = (file) => { const fd = new FormData(); fd.append('file', file); return API.post('/payment/proof', fd).then(r => r.data); };
export const uploadCover = (file) => { const fd = new FormData(); fd.append('file', file); return API.post('/couple/cover', fd).then(r => r.data); };
export const deleteCover = () => API.delete('/couple/cover').then(r => r.data);
export const adminPayments = (status) => API.get('/admin/payments', { params: status ? { status } : {} }).then(r => r.data);
export const adminStats = () => API.get('/admin/stats').then(r => r.data);
export const adminApprove = (id) => API.post(`/admin/payments/${id}/approve`).then(r => r.data);
export const adminReject = (id, reason) => API.post(`/admin/payments/${id}/reject`, { reason }).then(r => r.data);

// Public invitation
export const getInvitation = (slug) => API.get(`/inv/${slug}`).then(r => r.data);
export const sendRsvp = (slug, data) => API.post(`/inv/${slug}/rsvp`, data).then(r => r.data);
export const listRsvps = () => API.get('/rsvps').then(r => r.data);
export const invitationUrl = (slug, to) => `${BACKEND_URL}/inv/${slug}${to ? `?to=${encodeURIComponent(to)}` : ''}`;

// Couple
export const getCouple = () => API.get('/couple').then(r => r.data);
export const upsertCouple = (data) => API.put('/couple', data).then(r => r.data);

// Categories & tasks
export const listCategories = () => API.get('/categories').then(r => r.data);
export const createCategory = (data) => API.post('/categories', data).then(r => r.data);
export const deleteCategory = (id) => API.delete(`/categories/${id}`).then(r => r.data);
export const listTasks = (categoryId) => API.get('/tasks', { params: { categoryId } }).then(r => r.data);
export const createTask = (data) => API.post('/tasks', data).then(r => r.data);
export const updateTask = (id, data) => API.patch(`/tasks/${id}`, data).then(r => r.data);
export const deleteTask = (id) => API.delete(`/tasks/${id}`).then(r => r.data);

// Budget
export const listBudgetCats = () => API.get('/budget/categories').then(r => r.data);
export const createBudgetCat = (data) => API.post('/budget/categories', data).then(r => r.data);
export const updateBudgetCat = (id, data) => API.patch(`/budget/categories/${id}`, data).then(r => r.data);
export const deleteBudgetCat = (id) => API.delete(`/budget/categories/${id}`).then(r => r.data);
export const addBudgetItem = (cid, data) => API.post(`/budget/categories/${cid}/items`, data).then(r => r.data);
export const updateBudgetItem = (id, data) => API.patch(`/budget/items/${id}`, data).then(r => r.data);
export const deleteBudgetItem = (id) => API.delete(`/budget/items/${id}`).then(r => r.data);

// Expenses
export const listExpenses = () => API.get('/expenses').then(r => r.data);
export const createExpense = (data) => API.post('/expenses', data).then(r => r.data);
export const deleteExpense = (id) => API.delete(`/expenses/${id}`).then(r => r.data);

// Savings
export const getSavings = () => API.get('/savings').then(r => r.data);
export const addSaving = (data) => API.post('/savings', data).then(r => r.data);
export const deleteSaving = (id) => API.delete(`/savings/${id}`).then(r => r.data);
export const setSavingsTarget = (target) => API.put('/savings/target', { target }).then(r => r.data);

// Guests
export const listGuests = () => API.get('/guests').then(r => r.data);
export const createGuest = (data) => API.post('/guests', data).then(r => r.data);
export const updateGuest = (id, data) => API.patch(`/guests/${id}`, data).then(r => r.data);
export const deleteGuest = (id) => API.delete(`/guests/${id}`).then(r => r.data);
export const listGroups = () => API.get('/groups').then(r => r.data);
export const createGroup = (data) => API.post('/groups', data).then(r => r.data);
export const deleteGroup = (id) => API.delete(`/groups/${id}`).then(r => r.data);

export function formatRupiah(n) {
  if (n == null) return 'Rp 0';
  const num = Number(n);
  if (num >= 1000000) return `Rp ${(num/1000000).toFixed(num%1000000===0?0:1).replace('.',',')}jt`;
  if (num >= 1000) return `Rp ${(num/1000).toFixed(0)}rb`;
  return `Rp ${num}`;
}
export function formatRupiahFull(n) {
  if (n == null) return 'Rp 0';
  return 'Rp ' + Number(n).toLocaleString('id-ID');
}
